import React, { useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
import Navbar from "../components/Layouts/Navbar";
import HeroBanner from '../components/Common/HeroBanner';
import DButton from '../components/elements/DButton';
import Breadcrumb from '../components/Layouts/Breadcrumb';
import SectionHeading from "../components/Common/SectionHeading";
import Head from 'next/head';
import axios from 'axios';
const Footer = dynamic(() => import('../components/Layouts/Footer', { ssr: false }));


const RefundPolicy = () => {

  const [scrolled, setScrolled] = useState(0)
  const [scrolledStatus, setScrolledStatus] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.pageYOffset);
    // clean up code
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (scrolled > 30) {
      setScrolledStatus(true)
    }
  }, [scrolled])

  return (
    <>
      

      <Navbar />
      <>
        <HeroBanner
          background={process.env.IMG_CDN + "img/banner/refund-policy-page.webp"}
          title={<>DelveInsight&apos;s Refund Policy</>}
        />
        <Breadcrumb />
        <div className="w-11/12 xl:max-w-screen max-w-screen-2xl flex flex-col justify-center mx-auto lg:my-8 my-4">
          <SectionHeading
            title="Welcome to DelveInsight's Refund Policy"
          />
          <div className='grid grid-cols-12'>
            <div className='col-span-12'>
              <div className='text-justify'>
                <p>DelveInsight Business and Market Research offer its clients full post sales support. We set ourselves apart by exceeding our client’s expectations through a combination of high-quality, industry-specific marketing consultation, primary research, and analytical expertise at reasonable prices.</p>
                <p>As we deliver our reports in the form of a PDF. The use of our reports is based on the concept of knowledge transfer, and as it is intellectual property so, once the report is delivered, considering the type of deliverable it is, its not in our purview to cancel the order and offer refund to client post delivery.</p>
                <p>However, if the client has some query and to counter the refund, we offer <span className="text-[#1b5df3]">100% post-sales support</span>, in which we support our client and assist them.</p>
              </div>
            </div>
          </div>
        </div>
      </>
      {scrolledStatus && <>
        <Footer />
      </>}

    </>
  )
}

RefundPolicy.getInitialProps = async (NextPageContext) => {
  const slugData = NextPageContext.pathname
  try {
      const response = await axios.get(process.env.API_URL + '/meta' + slugData);
      return {
          title: (response?.data.meta_title) ? response?.data.meta_title : "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
          description: (response?.data.meta_description) ? response?.data.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
          keywords: (response?.data.meta_keywords) ? response?.data.meta_keywords : "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
      }
  } catch (error) {
      console.error('Error fetching data:', error.message);
      return {
          title: "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
          description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
          keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
      };
  }
}

export default RefundPolicy;